/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const Acceptance = lazyLoad(
  () => import('./index'),
  module => {
    return module.Acceptance;
  },
);
